import React, {createContext, useEffect, useState} from 'react';
import {useQuery, useMutation} from 'react-query';
import {api} from '../index';
// import {FrigadeProvider, FrigadeTour} from '@frigade/react';
// import {useSelector} from 'react-redux';

const TourContext = createContext(null);

function TourProvider(props) {
  const [tourState, setTourState] = useState({});
  // const {user: userData} = useSelector(state => state?.auth);

  const {data: user} = useQuery(
    'user',
    () => api.get('/users/me/profile').then(res => res.data),
    {
      enabled: false,
    },
  );

  // const fullName = `${userData?.first_name} ${userData?.last_name}`;

  useEffect(() => {
    if (user?.user) {
      const {
        aml_screening_tour,
        developers_tour,
        easy_lookup_tour,
        easy_onboard_tour,
        easy_onboard_tour_2,
        verifications_tour,
        team_tour,
      } = user.user;
      setTourState({
        aml_screening_tour,
        developers_tour,
        easy_lookup_tour,
        easy_onboard_tour,
        easy_onboard_tour_2,
        verifications_tour,
        team_tour,
      });
    }
  }, [user]);

  const updateTourStateMutation = useMutation(
    updatedState => api.put('/users/user', updatedState).then(res => res.data),
    {
      onSuccess: data => {
        if (user) {
          const {
            aml_screening_tour,
            developers_tour,
            easy_lookup_tour,
            easy_onboard_tour,
            easy_onboard_tour_2,
            verifications_tour,
            team_tour,
          } = data;
          setTourState({
            aml_screening_tour,
            developers_tour,
            easy_lookup_tour,
            easy_onboard_tour,
            easy_onboard_tour_2,
            verifications_tour,
            team_tour,
          });
        }
      },
    },
  );

  const updateTourState = updatedState => {
    updateTourStateMutation.mutate(updatedState);
  };

  return (
    <TourContext.Provider value={{tourState, updateTourState}}>
      {/*<FrigadeProvider*/}
      {/*  publicApiKey={process.env.REACT_APP_FRIGADE_PUBLIC_API_KEY}*/}
      {/*  userId={fullName}*/}
      {/*  generateGuestId={false}*/}
      {/*>*/}
      {/*  <FrigadeTour*/}
      {/*    flowId="flow_iGzDxVzT"*/}
      {/*    tooltipPosition="auto"*/}
      {/*    dismissible={true}*/}
      {/*    showStepCount={true}*/}
      {/*  />*/}
      {props.children}
      {/*</FrigadeProvider>*/}
    </TourContext.Provider>
  );
}

export {TourProvider, TourContext};
